<template>
  <div class="main_box">
    <div class="main_bar" v-if="false">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a href="javascript:void(0)" @click="openProjectGroupManager()">
            待评项目分组
          </a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <span class="currentSpan">
            （{{ projectGroupInfo.Name }}）待评项目
          </span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div>
        <el-button @click="openProjectGroupManager()"> 返回 </el-button>
        <el-button type="primary" @click="editProject(null)">
          新增项目
        </el-button>
        <el-button type="primary" @click="exportTemplate()">
          导出Excel模板
        </el-button>
        <el-button type="primary" @click="importData()"> 导入数据 </el-button>
      </div>
    </div>
    <div class="main_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <div class="condition_item">
            {{ projectGroupInfo.Name }}
          </div>
        </div>
        <div class="form_bar_btn">
          <div class="condition_item">
            <el-button @click="openProjectGroupManager()"> 返回 </el-button>
            <el-button
              type="primary"
              @click="editProject(null)"
              v-if="meetingInfo.MeetingType === 0"
            >
              新增项目
            </el-button>
            <el-button
              type="primary"
              @click="commonEditProject(null)"
              v-if="meetingInfo.MeetingType === 2"
            >
              新增选项
            </el-button>
          </div>
          <div class="condition_item">
            <el-button
              type="primary"
              @click="exportTemplate()"
              v-if="meetingInfo.MeetingType === 0"
            >
              导出Excel模板
            </el-button>
            <el-button
              type="primary"
              @click="exportCommonTemplate()"
              v-if="meetingInfo.MeetingType === 2"
            >
              导出Excel模板
            </el-button>
            <el-button
              type="primary"
              @click="importData()"
              v-if="meetingInfo.MeetingType === 0"
            >
              导入数据
            </el-button>
            <el-button
              type="primary"
              @click="commonImportExcel()"
              v-if="meetingInfo.MeetingType === 2"
            >
              导入数据
            </el-button>
          </div>
        </div>
      </div>
      <el-table
        v-loading="tableLoading"
        :data="projectList"
        style="width: 100%"
        stripe
      >
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="60"
        ></el-table-column>
        <el-table-column
          property="Project"
          :label="meetingInfo.MeetingType === 0 ? '项目名称' : '标题'"
        >
        </el-table-column>
        <el-table-column
          property="Remark"
          :label="meetingInfo.MeetingType === 0 ? '单位名称' : '补充信息'"
          align="center"
        >
        </el-table-column>
        <el-table-column label="显示顺序" width="70" align="center" key="Sort">
          <template slot-scope="scope">
            <span>{{ scope.row.Sort }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="editProject(scope.row.Id)"
              v-if="meetingInfo.MeetingType === 0"
            >
              编辑
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="commonEditProject(scope.row.Id)"
              v-if="meetingInfo.MeetingType === 2"
            >
              编辑
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="deleteProject(scope.row)"
              v-if="scope.row.VoteNames.length === 0"
            >
              删除
            </el-link>
            <el-popover placement="left" width="400" trigger="hover">
              <el-table :data="scope.row.VoteNames">
                <el-table-column width="400" label="被以下投票使用">
                  <template slot-scope="scope1">
                    <span>{{ scope1.row }}</span>
                  </template></el-table-column
                >
              </el-table>
              <el-link
                title="被以下投票使用"
                type="primary"
                class="cell_link"
                slot="reference"
                v-if="scope.row.VoteNames.length !== 0"
                :disabled="scope.row.VoteNames.length !== 0"
              >
                删除
                <i class="el-icon-connection el-icon--right"></i>
              </el-link>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination_box">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="listQuery.MaxResultCount"
          :layout="pagination_layout"
          :total="listTotalCount"
        >
        </el-pagination>
      </div>
      <EditProject
        :ProjectGroupID="projectGroupId"
        :MeetingID="meetingId"
        :fatherSubmitDialog="editProjectDialog"
        ref="editProject"
      ></EditProject>
      <ImportExcel
        :fatherSubmitDialog="importExcelDialog"
        ref="importProject"
      ></ImportExcel>
      <CommonEditProject
        :ProjectGroupID="projectGroupId"
        :MeetingID="meetingId"
        :fatherSubmitDialog="editProjectDialog"
        ref="commonEditProject"
      ></CommonEditProject>
      <CommonImportExcel
        :fatherSubmitDialog="importExcelDialog"
        ref="commonImportExcel"
      ></CommonImportExcel>
    </div>
  </div>
</template>
<script>
import voteProjectApi from '../../../api/vote/voteProject'
import EditProject from '@/components/project/EditProject.vue'
import ImportExcel from '@/components/project/ImportExcel.vue'
import CommonEditProject from '@/components/project/CommonEditProject.vue'
import CommonImportExcel from '@/components/project/CommonImportExcel.vue'
export default {
  name: 'Project',
  components: {
    EditProject,
    ImportExcel,
    CommonEditProject,
    CommonImportExcel
  },
  data () {
    return {
      meetingId: null,
      projectGroupId: null,
      tableLoading: true,
      projectList: [],
      listTotalCount: 0,
      currentPage: 1,
      listQuery: {
        ProjectGroupId: null,
        maxResultCount: 10,
        skipCount: 0
      },
      projectGroupInfo: {},
      pagination_layout: 'prev, pager, next'
    }
  },
  props: ['meetingInfo'],
  methods: {
    getProjectGroup: function () {
      this.tableLoading = true
      voteProjectApi.getProjectGroup({
        projectGroupId: this.projectGroupId
      }).then(data => {
        this.projectGroupInfo = data
        this.getProjects()
      }).catch(err => {
        return err
      })
    },
    getProjects: function () {
      this.tableLoading = true
      voteProjectApi.getProjects(this.listQuery).then(data => {
        this.projectList = data.Items
        this.listTotalCount = data.TotalCount
        this.tableLoading = false
      }).catch(err => {
        this.tableLoading = false
        return err
      })
    },
    handleSizeChange (val) {
      this.listQuery.maxResultCount = val
      this.getProjects()
    },
    handleCurrentChange (val) {
      this.listQuery.skipCount = (val - 1) * this.listQuery.maxResultCount
      this.getProjects()
    },
    deleteProject: function (item) {
      let deleteMessage = '确认删除项目“' + item.Project + '”吗？'
      if (this.meetingInfo.MeetingType === 2) {
        deleteMessage = '确认删除选项“' + item.Project + '”吗？'
      }
      this.$confirm(deleteMessage, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = this.openLoading('删除中…')
        voteProjectApi.deleteProject({
          projectId: item.Id
        }).then(data => {
          openLoading.close()
          this.getProjects()
          this.$message({
            type: 'success',
            message: '删除成功!',
            customClass: 'custom_message'
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          customClass: 'custom_message'
        })
      })
    },
    editProject: function (projectId) {
      this.$refs.editProject.openEditProject(projectId)
    },
    editProjectDialog: function () {
      this.getProjects()
    },
    commonEditProject: function (projectId) {
      this.$refs.commonEditProject.openEditProject(projectId)
    },
    openProjectGroupManager: function () {
      if (this.meetingInfo.MeetingType === 0) {
        this.$router.push({ name: 'voteProjectGroup', params: { mid: this.$route.params.mid, vid: this.$route.params.vid } })
      }
      if (this.meetingInfo.MeetingType === 2) {
        this.$router.push({ name: 'publicVoteProjectGroup', params: { mid: this.$route.params.mid, vid: this.$route.params.vid } })
      }
    },
    indexMethod (index) {
      return this.listQuery.skipCount + index + 1
    },
    exportTemplate: function () {
      const openLoading = this.openLoading('正在导出…')
      voteProjectApi.exportProjectTemplate({
        MeetingId: this.$route.params.mid,
        ProjectGroupId: this.projectGroupId
      }).then(data => {
        if (!data) {
          return
        }
        let fileName = '待评项目'
        if (this.projectGroupId) {
          fileName = this.projectGroupInfo.Name
        }
        const fileUrl = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel;charset=utf-8' }))

        const elink = document.createElement('a')
        // 设置下载文件名
        elink.setAttribute('download', fileName + '.xlsx')
        elink.style.display = 'none'
        elink.href = fileUrl
        document.body.appendChild(elink)
        elink.click()

        document.body.removeChild(elink) // 下载完成移除元素
        window.URL.revokeObjectURL(fileUrl) // 释放掉blob对象
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    exportCommonTemplate: function () {
      const openLoading = this.openLoading('正在导出…')
      voteProjectApi.exportCommonProjectTemplate({
        MeetingId: this.$route.params.mid,
        ProjectGroupId: this.projectGroupId
      }).then(data => {
        if (!data) {
          return
        }
        let fileName = '投票选项'
        if (this.projectGroupId) {
          fileName = this.projectGroupInfo.Name
        }
        const fileUrl = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel;charset=utf-8' }))

        const elink = document.createElement('a')
        // 设置下载文件名
        elink.setAttribute('download', fileName + '.xlsx')
        elink.style.display = 'none'
        elink.href = fileUrl
        document.body.appendChild(elink)
        elink.click()

        document.body.removeChild(elink) // 下载完成移除元素
        window.URL.revokeObjectURL(fileUrl) // 释放掉blob对象
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    importData: function () {
      this.$refs.importProject.openImportExcel(this.projectGroupId, this.$route.params.mid)
    },
    importExcelDialog: function (projectGroupID) {
      // this.getProjects()
      this.$router.push({ name: 'voteProject', params: { mid: this.$route.params.mid, gid: projectGroupID, vid: this.$route.params.vid } })
      this.init()
    },
    commonImportExcel: function () {
      this.$refs.commonImportExcel.openImportExcel(this.projectGroupId, this.$route.params.mid)
    },
    init: function () {
      this.meetingId = this.$route.params.mid
      this.projectGroupId = this.$route.params.gid
      this.listQuery.ProjectGroupId = this.$route.params.gid
      this.getProjectGroup()
    }
  },
  computed: {

  },
  created () {
    this.init()
    if (this.is_xs) {
      this.pagination_layout = 'total,prev, pager, next'
    } else {
      this.pagination_layout = 'total, sizes, prev, pager, next, jumper'
    }
  }
}
</script>
